module.exports = __webpack_public_path__ + "static/media/0_2019_07_01-4.e232a182.jpg";